.list {
  list-style: none;
  display: flex;
  color: var(--cxy-color-text-default-body);
  font-weight: var(--cxy-fontWeight-bold);
  font-family: var(--cxy-font-family-futura);
  flex-wrap: wrap;
}

.listItem {
  display: flex;
  align-items: center;
  align-items: flex-start;
}

.listItemText {
  align-self: center;
}

.iconWrapper {
  background: var(--cxy-color-brand);
  border-radius: var(--cxy-list-icon-borderRadius, 50%);

  display: flex;
  justify-content: center;
  align-items: center;
}

.check {
  color: var(--cxy-color-icon-checkbox);
}

.size--s {
  font-size: var(--cxy-fontSize-s);
  gap: var(--cxy-spacing-xxsm);

  .listItem {
    gap: var(--cxy-spacing-xxxsm);
  }

  .iconWrapper {
    min-height: 22px;
    min-width: 22px;
  }
}

.size--m {
  font-size: var(--cxy-fontSize-m);
  gap: var(--cxy-spacing-xsm);

  .listItem {
    gap: var(--cxy-spacing-xxsm);
  }

  .iconWrapper {
    min-height: 28px;
    min-width: 28px;
  }
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .iconWrapper {
    background-color: var(--cxy-color-success);
  }
}
